import { LinePath } from '@visx/shape'

import {
  INHERITANCE_ARROW_HEIGHT,
  NODE_SPACING_HORIZONTAL,
  NODE_SPACING_VERTICAL,
} from './constants'
import type { Node } from './types'

type Props = {
  parent: Node
  child: Node
}

export const InheritancePathHorizontal = ({ parent, child }: Props) => {
  const [x0, y0] = [
    parent.position.x + parent.boundingBox.width / 2,
    parent.position.y + parent.boundingBox.height + INHERITANCE_ARROW_HEIGHT,
  ]
  const [x1, y1] = [
    x0,
    y0 + (NODE_SPACING_VERTICAL - INHERITANCE_ARROW_HEIGHT) / 2,
  ]
  const [x2, y2] = [
    (() => {
      if (
        parent.children[0].position.y === child.position.y &&
        child.position.x < x1 &&
        x1 < child.position.x + child.boundingBox.width
      ) {
        // Child Y position is at the start and the X fits under the parent's boundingBox.
        // We can make a straight line.
        return x1
      }

      return child.connection === 'center'
        ? child.position.x + child.boundingBox.width / 2
        : child.position.x +
            child.boundingBox.width -
            NODE_SPACING_HORIZONTAL / 2
    })(),
    y1,
  ]
  const [x3, y3] = [x2, child.position.y]

  return (
    <LinePath
      data={[
        [x0, y0],
        [x1, y1],
        [x2, y2],
        [x3, y3],
      ]}
      className="stroke-inheritance stroke-1"
      shapeRendering="auto"
    />
  )
}
